<template lang="pug">
  div.module-title
    div.bar
    span {{title}}
</template>

<script>
export default {
  name: 'ModuleTitle',
  props: ['title']
}
</script>

<style lang="scss" scoped>
  .module-title{
    display: flex;
    align-items: center;
    .bar{
      width: 4px;
      height: 14px;
      background-color: #f87653;
      border-radius: 2px;
      margin-right: 9px;
    }
    span{
      color: #333;
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventCenter/ModuleTitle.vue